"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Checkbox", {
  enumerable: true,
  get: function () {
    return _Checkbox.default;
  }
});
Object.defineProperty(exports, "CheckboxGroup", {
  enumerable: true,
  get: function () {
    return _CheckboxGroup.default;
  }
});
Object.defineProperty(exports, "DateInput", {
  enumerable: true,
  get: function () {
    return _DateInput.default;
  }
});
Object.defineProperty(exports, "DateInputRange", {
  enumerable: true,
  get: function () {
    return _DateInputRange.default;
  }
});
Object.defineProperty(exports, "Paragraph", {
  enumerable: true,
  get: function () {
    return _Paragraph.default;
  }
});
Object.defineProperty(exports, "RadioButton", {
  enumerable: true,
  get: function () {
    return _RadioButton.default;
  }
});
Object.defineProperty(exports, "RadioButtonGroup", {
  enumerable: true,
  get: function () {
    return _RadioButtonGroup.default;
  }
});
Object.defineProperty(exports, "Select", {
  enumerable: true,
  get: function () {
    return _Select.default;
  }
});
Object.defineProperty(exports, "TextInput", {
  enumerable: true,
  get: function () {
    return _TextInput.default;
  }
});
Object.defineProperty(exports, "ToggleButtons", {
  enumerable: true,
  get: function () {
    return _ToggleButtons.default;
  }
});
exports.availableComponents = void 0;
var _TextInput = _interopRequireDefault(require("./TextInput"));
var _RadioButton = _interopRequireDefault(require("./RadioButton"));
var _RadioButtonGroup = _interopRequireDefault(require("./RadioButtonGroup"));
var _Checkbox = _interopRequireDefault(require("./Checkbox"));
var _CheckboxGroup = _interopRequireDefault(require("./CheckboxGroup"));
var _DateInput = _interopRequireDefault(require("./DateInput"));
var _DateInputRange = _interopRequireDefault(require("./DateInputRange"));
var _ToggleButtons = _interopRequireDefault(require("./ToggleButtons"));
var _Select = _interopRequireDefault(require("./Select"));
var _Paragraph = _interopRequireDefault(require("../../elements/Paragraph"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// all components needed

const availableComponents = exports.availableComponents = ['TextInput', 'RadioButton', 'Select', 'RadioButtonGroup', 'Checkbox', 'CheckboxGroup', 'DateInput', 'DateInputRange', 'Paragraph', 'ToggleButtons'];
//# sourceMappingURL=DynamicComponents.js.map